import { render, staticRenderFns } from "./RoamPathList.vue?vue&type=template&id=59b87758&scoped=true"
import script from "./RoamPathList.vue?vue&type=script&lang=js"
export * from "./RoamPathList.vue?vue&type=script&lang=js"
import style0 from "./RoamPathList.vue?vue&type=style&index=0&id=59b87758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b87758",
  null
  
)

export default component.exports